import React, { useEffect, useMemo } from "react"
import classnames from "classnames"
import PropTypes from "prop-types"
import("../styles/fadeIn.scss")

const FadeIn = props => {
  const [isVisible, setVisible] = React.useState(true)
  const [isLoaded, setLoaded] = React.useState(false)
  let domRef = React.useRef(null)
  const config = useMemo(() => {
    return {
      root: null,
      rootMargin: "0px",
      threshold: props.threshold,
    }
  }, [props.threshold])
  useEffect(() => {
    let timer1 = setTimeout(() => setLoaded(true), 10)
    return () => {
      clearTimeout(timer1)
    }
  }, [])

  useEffect(() => {
    setVisible(false)
    let observer = null
    let currentElement = domRef.current
    if (typeof window !== `undefined` && !!window.IntersectionObserver) {
      observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setVisible(true)
            if (observer) {
              observer.unobserve(entry.target)
            }
          }
        })
      }, config)
    }

    if (observer !== null) {
      observer.observe(currentElement)
    }

    return () => {
      if (observer !== null) {
        observer.unobserve(currentElement)
      }
    }
  }, [config])

  if (props.type === "span") {
    return (
      <span
        style={{ transitionDelay: props.delay + "ms" }}
        className={classnames({
          fadeInHidden: true,
          fadeWrapper: true,
          isVisible: isVisible && isLoaded,
          transitionUp: props.animation === "up",
          transitionDown: props.animation === "down",
          transitionLeft: props.animation === "left",
          transitionRight: props.animation === "right",
          removeOnMobile: props.removeOnMobile,
          inline: props.type === "span",
        })}
        ref={domRef}
      >
        {props.children}
      </span>
    )
  } else {
    return (
      <div
        style={{ transitionDelay: props.delay + "ms" }}
        className={classnames({
          fadeInHidden: true,
          fadeWrapper: true,
          isVisible: isVisible && isLoaded,
          transitionUp: props.animation === "up",
          transitionDown: props.animation === "down",
          transitionLeft: props.animation === "left",
          transitionRight: props.animation === "right",
          removeOnMobile: props.removeOnMobile,
        })}
        ref={domRef}
      >
        {props.children}
      </div>
    )
  }
}

FadeIn.defaultProps = {
  children: null,
  threshold: 0.4,
  delay: 0,
  removeOnMobile: false,
  animation: "up",
  type: "div",
}

FadeIn.propTypes = {
  children: PropTypes.node,
  threshold: PropTypes.number,
  delay: PropTypes.number,
  removeOnMobile: PropTypes.bool,
  animation: PropTypes.oneOf(["up", "down", "left", "right", "fade"]),
  type: PropTypes.oneOf(["div", "span"]),
}

export default FadeIn
